import { CommerceMedia } from '@api/types';
import { createContext } from 'react';

export type GalleryContextType = {
  images?: CommerceMedia[];
  currentImage: number;
  setCurrentImage: Function;
  isModalOpen: boolean;
  setIsModalOpen: Function;
};

export const GalleryContext = createContext<GalleryContextType>({
  images: [],
  currentImage: 0,
  setCurrentImage: () => null,
  isModalOpen: false,
  setIsModalOpen: () => null,
});
